import { styled, css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const AdUnitComponent = styled.div<{ withBorder?: boolean; withPadding?: boolean }>`
    white-space: normal;
    width: 100%;
    ${({ withPadding }) => withPadding && `padding: 16px 16px;`};
    ${({ withBorder }) => withBorder && `border: 1px solid ${colorsPalettes.midnight["50"]}`};
    display: flex;
    flex-direction: column;
    & > * {
        margin: 0;
        line-height: normal;
        font-size: 12px;
    }
    p {
        color: #444;
    }
`;

export const AdPreview = styled.span`
    height: 16px;
    color: ${rgba(colorsPalettes.carbon[500], 0.6)};
    font-style: normal;
    font-size: 12px;
    word-break: break-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const AdPreviewPrefix = styled.span`
    color: ${colorsPalettes.carbon[300]};
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    &::after {
        content: "";
        background: ${rgba(colorsPalettes.carbon[500], 0.6)};
        width: 3px;
        height: 3px;
        border-radius: 50%;
        position: relative;
        margin-left: 5px;
        margin-right: 5px;
    }
`;

export const H3Container = styled.div`
    padding-bottom: 4px;
`;

export const ItemIconContainer = styled.div`
    display: inline-block;
    width: 24px;
    margin-right: 12px;
`;

export const AdTargetUrl = styled.a``;
export const AdDescription = styled.p``;

export const TextAdWrapper = styled.div`
    width: 100%;
    ${AdUnitComponent} {
        height: 100%;
        justify-content: center;
        ${AdPreview} {
            font-size: 14px;
            margin-bottom: 4px;
        }
        ${H3Container} {
            ${AdTargetUrl} {
                max-width: 100%;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                overflow-wrap: break-word;
                display: -webkit-box;
                align-self: center;
                font-size: 16px;
                line-height: 24px;
                font-family: "DM Sans";
            }
            padding-bottom: unset;
            margin-bottom: 4px;
            display: flex;
        }
        ${AdDescription} {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            overflow-wrap: break-word;
            font-size: 14px;
            line-height: 20px !important;
        }
    }
`;

export const ShoppingAdContainer = styled.div<{ isImgClickable?: boolean }>`
    display: flex;
    line-height: 1.6em;
    width: 100%;

    img {
        max-width: 121px;
        max-height: 121px;
    }

    .details {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        align-self: center;
    }

    .price {
        font-weight: 600;
        color: ${colorsPalettes.carbon["500"]};
    }

    .title {
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        color: ${colorsPalettes.carbon["400"]};
    }
    .brand {
        color: ${colorsPalettes.carbon["500"]};
    }
`;

export const ImageContainer = styled.div<{ isImgClickable?: boolean }>`
    margin-right: 16px;
    border: 1px solid ${colorsPalettes.midnight[50]};
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 123px;
    min-height: 123px;
    background-color: #fff;
    ${({ isImgClickable }) =>
        isImgClickable &&
        css`
            cursor: pointer;
        `};
`;

export const ShoppingAdWrapper = styled.div<{ fixedImageHeight?: boolean }>`
    ${({ fixedImageHeight = true }) =>
        fixedImageHeight &&
        `
    ${ImageContainer} {
        height: 116px;
        min-height: unset;
    }`}
`;
